import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import MetaTags from 'react-meta-tags';
import Gallery1 from '../assets/images/Gallery/g1.webp';
import Gallery2 from '../assets/images/Gallery/g2.webp';
import Gallery3 from '../assets/images/Gallery/g3.webp';
import Gallery4 from '../assets/images/Gallery/g4.webp';
import Gallery5 from '../assets/images/Gallery/g5.webp';
import Gallery6 from '../assets/images/Gallery/g6.webp';
import Gallery7 from '../assets/images/Gallery/g7.webp';
import Gallery8 from '../assets/images/Gallery/g8.webp';
import Gallery9 from '../assets/images/Gallery/g9.webp';
import Gallery10 from '../assets/images/Gallery/g10.webp';
import Gallery11 from '../assets/images/Gallery/g11.webp';
import Gallery12 from '../assets/images/Gallery/g12.webp';
import Gallery13 from '../assets/images/Gallery/g13.webp';
import Gallery14 from '../assets/images/Gallery/g14.webp';
import Gallery15 from '../assets/images/Gallery/g15.webp';
import Gallery16 from '../assets/images/Gallery/g16.webp';
import Gallery17 from '../assets/images/Gallery/g17.webp';
import Gallery18 from '../assets/images/Gallery/g18.webp';
import Gallery19 from '../assets/images/Gallery/g55.webp'
import Gallery20 from '../assets/images/Gallery/g54.webp'
import Gallery21 from '../assets/images/Gallery/g53.webp'
import Gallery22 from '../assets/images/Gallery/g52.webp'
import Gallery23 from '../assets/images/Gallery/g51.webp'
import Gallery24 from '../assets/images/Gallery/g50.webp'
import Gallery25 from '../assets/images/Gallery/g49.webp'
import Gallery26 from '../assets/images/Gallery/g48.webp'
import Gallery27 from '../assets/images/Gallery/g47.webp'
import Gallery28 from '../assets/images/Gallery/g46.webp'
import Gallery29 from '../assets/images/Gallery/g45.webp'
import Gallery30 from '../assets/images/Gallery/g34.webp'
import Gallery31 from '../assets/images/Gallery/g43.webp'
import Gallery32 from '../assets/images/Gallery/g42.webp'
import Gallery33 from '../assets/images/Gallery/g41.webp'
import Gallery34 from '../assets/images/Gallery/g40.webp'
import Gallery35 from '../assets/images/Gallery/g39.webp'
import Gallery36 from '../assets/images/Gallery/g33.webp'
import Gallery37 from '../assets/images/Gallery/g37.webp'
import Gallery38 from '../assets/images/Gallery/g36.webp'
import Gallery39 from '../assets/images/Gallery/g35.webp'
import Gallery40 from '../assets/images/Gallery/g34.webp'
import Gallery41 from '../assets/images/Gallery/g33.webp'
import Gallery42 from '../assets/images/Gallery/g32.webp'
import Gallery43 from '../assets/images/Gallery/g30.webp'
import Gallery44 from '../assets/images/Gallery/g29.webp'
import Gallery45 from '../assets/images/Gallery/g31.webp'
import { gallery } from '../MetaTags';

export default function Gallery() {
  const images = [Gallery1, Gallery2, Gallery3, Gallery4, Gallery5, Gallery6,Gallery7,Gallery8,Gallery9,Gallery10,Gallery11,Gallery12,Gallery13,Gallery14,Gallery15,Gallery16,Gallery17,Gallery18,Gallery19,Gallery20,Gallery21,Gallery22,Gallery23,Gallery24,Gallery25,Gallery26,Gallery27,Gallery28,Gallery29,Gallery30,Gallery31,Gallery32,Gallery33,Gallery34,Gallery35,Gallery36,Gallery37,Gallery38,Gallery39,Gallery40,Gallery41,Gallery42,Gallery43,Gallery44,Gallery45];

  const [show, setShow] = useState(false);
  const [currentImg, setCurrentImg] = useState('');

  const handleShow = (img) => {
    setCurrentImg(img);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <>
    <div>
      <MetaTags>
                <title>{gallery.title}</title>
                <meta name="description" content={gallery.description} />
                <link rel="canonical" href={gallery.canonical} />
            </MetaTags>
    <section id="breadcrumbs" class="breadcrumbs">
                <div class="container">
                    <h1>Our Project Gallery</h1>
                    <ul>
                        <li><a href="./">Home</a></li>
                        <li>Gallery</li>
                    </ul>
                </div>
            </section>
    <Container className="gallery-main my-5">
      <Row>
        {images.map((img, index) => (
          <Col md={4} sm={6} xs={12} className="mb-4" key={index}>
            <div
              className="gallery-card"
              onClick={() => handleShow(img)}
              style={{
                cursor: 'pointer',
                overflow: 'hidden',
                borderRadius: '12px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
              }}
            >
              <img
                src={img}
                alt={`Gallery ${index + 1}`}
                className="img-fluid gallery-img-main"
                style={{
                  transition: 'transform 0.3s',
                  width: '100%',
                  height: '250px',
                  objectFit: 'cover',
                }}
              />
            </div>
          </Col>
        ))}
      </Row>
      {/* Modal for image view */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body className="p-0">
          <img src={currentImg} alt="Enlarged" className="img-fluid w-100" />
        </Modal.Body>
      </Modal>
    </Container>
    </div>
    </>
  );
}
